export default [{
  _name: 'CSidebarNav',
  _children: [
    {
      _name: 'CSidebarNavItem',
      name: 'Dashboard',
      to: '/dashboard',
      icon: 'cil-speedometer',
      /*
      badge: {
        color: 'primary',
        text: 'NEW'
      }
      */
    },
    {
      _name: 'CSidebarNavTitle',
      _children: ['Gestion des unités']
    },    

    {
      _name: 'CSidebarNavItem',
      name: 'Propriétés',
      to: '/SN/SNdevices',
      icon: 'cil-puzzle',
    },
    {
      _name: 'CSidebarNavItem',
      name: 'Types et micrologiciels',
      to: '/SN/SNprops',
      icon: 'cil-puzzle',
      /*
      badge: {
        color: 'primary',
        text: 'NEW'
      }
      */
    },    
    {
      _name: 'CSidebarNavItem',
      name: 'Localisation',
      to: '/SN/SNLocalisation',
      icon: 'cil-puzzle'
    },
    {
      _name: 'CSidebarNavTitle',
      _children: ['Messages']
    }, 
    {
      _name: 'CSidebarNavItem',
      name: 'Recus',
      to: '/SN/SNmessages',
      icon: 'cil-puzzle'
    },
    {
      _name: 'CSidebarNavItem',
      name: 'Envoyé',
      to: '/SN/SNemits',
      icon: 'cil-puzzle'
    }
/*  ,
    {
      _name: 'CSidebarNavDivider'
    },
    {
      _name: 'CSidebarNavTitle',
      _children: ['Session']
    },
    {
      _name: 'CSidebarNavDropdown',
      name: 'Pages',
      route: '/pages',
      icon: 'cil-star',
      items: [
        {
          name: 'Login',
          to: '/pages/login'
        },
        {
          name: 'Register',
          to: '/pages/register'
        },
        {
          name: 'Error 404',
          to: '/pages/404'
        },
        {
          name: 'Error 500',
          to: '/pages/500'
        }
      ]
    }
    */
  ]
}]